module.exports = {"Alodine":"Alodine","Anodize":"Anodize","Chem Film":"Chem Film","Dry Film Lube":"Dry Film Lube","Nickel Plating":"Nickel Plating"}


//////////////////
// WEBPACK FOOTER
// ./src/config/surfaceTreatments.json
// module id = 5417
// module chunks = 1